<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900">
    <template #title>{{ title }}</template>
    <v-data-table
      :items="items"
      :headers="headers"
      :loading="$apollo.loading"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.reference="{ item }">
        <reference-label
          v-model="item.reference"
          :itinerary-id="item.id"
        ></reference-label>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | formatDate }}
      </template>
      <template v-slot:item.startDate="{ item }">
        {{ item.startDate | formatDate }}
      </template>
      <template v-slot:item.totalPrice="{ item }">
        {{ item.currencyCode }}{{ item.totalPrice }}
      </template>
      <template v-slot:item.profit.netProfit="{ item }">
        {{ item.currencyCode
        }}{{ (item.profit ? item.profit.netProfit : 0) | priceLabeler }}
      </template>
    </v-data-table>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog";
import ReferenceLabel from "../../shared/labels/ReferenceLabel.vue";
import { removeGQLTypename } from "../../../../helpers";

const BOOKED_ITINERARIES = gql`
  query departureBookedItineraries($filter: ItineraryFilterType) {
    itineraries(first: 1000, filter: $filter) {
      totalCount
      edges {
        node {
          id
          reference
          createdAt
          clientName
          bookingStatus
          startDate
          adults
          children
          totalPrice
          currencyCode
          profit {
            netProfit
          }
        }
      }
    }
  }
`;

export default {
  name: "OpenGroupDepartureBookedListDialog",

  props: {
    show: { type: Boolean, default: false },
    departure: { type: Object, default: () => null },
  },

  components: {
    BasicDialog,
    ReferenceLabel,
  },

  data() {
    return {
      itineraries: {},
      headers: [
        { text: "Reference", value: "reference" },
        { text: "Created", value: "createdAt" },
        { text: "Client", value: "clientName" },
        { text: "Status", value: "bookingStatus" },
        { text: "Start Date", value: "startDate" },
        { text: "Adults", value: "adults" },
        { text: "Children", value: "children" },
        { text: "Price", value: "totalPrice" },
        { text: "Net Profit", value: "profit.netProfit" },
      ],
    };
  },

  computed: {
    title() {
      return this.departure
        ? `Booked Itineraries — ${this.departure.name} (${this.$options.filters.formatDate(
            this.departure.startDate
          )})`
        : "Booked Itineraries";
    },
    items() {
      return this.itineraries && this.itineraries.edges
        ? this.itineraries.edges.map(removeGQLTypename)
        : [];
    },
  },

  apollo: {
    itineraries: {
      query: BOOKED_ITINERARIES,
      variables() {
        return {
          filter: { openGroupDepartureId_eq: this.departure.id },
        };
      },
      skip() {
        return !this.show || !this.departure;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/open-groups/builder/OpenGroupDepartureBookedListDialog.vue